import { defineMessages } from 'react-intl';

export default defineMessages({
    ratingYourPolicyMessage: {
        id: 'quoteandbind.eh.directives.MultiQuoteView.Please wait while we rate your policy...',
        defaultMessage: 'Please wait while we rate your policy...'
    },
    creatingYourOfferingMessage: {
        id: 'quoteandbind.eh.directives.MultiQuoteView.Please wait while we create your offering...',
        defaultMessage: 'Please wait while we create your offering...'
    },
    baseCoverages: {
        id: 'quoteandbind.eh.directives.HoOfferingSelection.defaultBaseCoverages.General Coverages',
        defaultMessage: 'General Coverages'
    },
    additionalCoverages: {
        id: 'quoteandbind.eh.directives.HoOfferingSelection.defaultAdditionalCoverages.Additional Coverages',
        defaultMessage: 'Additional Coverages'
    },
    sectionICoverages: {
        id: 'quoteandbind.eh.directives.HoOfferingSelection.defaultAdditionalCoverages.sectionICoverages',
        defaultMessage: 'Section I Coverages'
    },
    sectionIICoverages: {
        id: 'quoteandbind.eh.directives.HoOfferingSelection.defaultAdditionalCoverages.sectionIICoverages',
        defaultMessage: 'Section II Coverages'
    },
    deductibles: {
        id: 'quoteandbind.eh.directives.HoOfferingSelection.defaultAdditionalCoverages.Deductibles',
        defaultMessage: 'Deductibles'
    },
});
